import React, { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import { Container } from "./styles";
import { Button, Menu, MenuItem } from "@mui/material";
import options from "../../../../assets/Icons/options.svg";
import { getImageProduct } from "./utils.jsx";
const Card = ({ id, nameList, products, images, onDeleteWishlist, onUpdateWishlist, openModal, closeModal, addNotification }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [user] = useState(JSON.parse(sessionStorage.getItem("user")));
  const [processedImages, setProcessedImages] = useState([]);
  const newWishlistRef = useRef(null);
  const history = useHistory();

  const handleDelete = () =>{
    openModal({
      className: "modal-delete",
      title: 'Eliminar Wishlist',
      text: 'La lista se eliminará de forma permanente. Los productos se conservarán y pasaran a productos no listados. ¿Deseas eliminar esta wishlist?',
      customComponent: null,
      showAccept:false,
      showCancel:true,
      onCancelClick: closeModal,
      buttons: [
        {
          label: "Sí, eliminar",
          onClick: () => {
              onDeleteWishlist(id, addNotification);
              closeModal();
          },
          className: "btn-guardar",
        },
      ]
    });
  }

  const handleUpdate = () =>{
    openModal({
      className:"modal-update",
      title: 'Actualizar Wishlist',
      text: 'Ingresa el nuevo nombre para tu wishlist',
      customComponent: (
        <input className="input-wishlist" defaultValue={nameList} ref={newWishlistRef}/>
      ),
      showAccept:false,
      showCancel:true,
      onCancelClick: () => {
        closeModal();
      },
      buttons: [
        {
          label: "Actualizar",
          onClick: () => {
            const newWishlistName = newWishlistRef.current?.value || ""; 
            if (newWishlistName.trim()) {
              onUpdateWishlist(newWishlistName, id, addNotification);
            } else {
              addNotification('error','El nombre de la nueva wishlist no puede estar vacío');
            }
            closeModal();
          },
          className: "btn-guardar",
        },
      ]
    });
  }
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    const fetchImages = async () => {
      const urls = await Promise.all(
        images.map((src) => getImageProduct(src, 900, 900))
      );
      setProcessedImages(urls);
    };

    fetchImages();
  }, [images]);

  const handleWishlistClick = () => {
    const selectedWishlist = [{
      id: id,
      name: nameList,
  }];
  
    history.push("/merchants", { user, selectedWishlist });
  };
  


  return (
    <Container id={id}>
      <div className="header-card" onClick={handleWishlistClick}>
        {processedImages.slice(0, 4).map((imgURL, index) => (
          <img
            key={index}
            src={imgURL}
            alt={`Image ${index}`}
            className="wishlist-image"
          />
        ))}
      </div>
      <div className="footer-card">
        <div className="name-options">
          <p className="name-wishlist">{nameList}</p>
          <Button
            id="basic-button"
            aria-controls={Boolean(anchorEl) ? "basic-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={Boolean(anchorEl) ? "true" : undefined}
            onClick={handleClick}
            sx={{ minWidth: "20px" }}
          >
            <img src={options} alt="" />
          </Button>
          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleClose}
            MenuListProps={{
              "aria-labelledby": "basic-button",
            }}
            sx={{
              ul: {
                paddingTop: "0px",
                paddingBottom: "0px",
              },
            }}
          >
            <MenuItem
              onClick={(event) => {
                event.stopPropagation();
                handleUpdate();
              }}
              sx={{
                fontSize: "12px",
                color: "#262626",
                minHeight: "auto",
                fontFamily: "Roboto",
              }}
            >
              Actualizar nombre
            </MenuItem>
            <MenuItem
              onClick={handleDelete}
              sx={{
                fontSize: "12px",
                color: "#262626",
                minHeight: "auto",
              }}
            >
              Eliminar
            </MenuItem>
          </Menu>
        </div>
        <p className="products">
          {products === 1 ? `${products} producto` : `${products} productos`}
        </p>
      </div>
    </Container>
  );
};

export default Card;
